import { activeSectionInfo } from "../Models/applicationModels";
import { CommonResponseModel, userDetailValueModel } from "../Models/tableDetailsModel";

export const EMPTY_USER_DETAIL: CommonResponseModel<userDetailValueModel> = {
    flagStatus: false,
    value: {
        devId: "",
        emailId: "",
        userRoles: []
    },
    error: null
}

export const DEFAULT_ACTIVE_SECTION: activeSectionInfo = {
    activeSection: 'insights',
    activeSubSection: null
}

export const ANTD_THEME_CONFIG = {
    token: {
        colorPrimary: "#3EAE54",
        colorPrimaryHover: "#369a4a",
        colorPrimaryBorder: "#3EAE54",
    }
}